export default "__VITE_ASSET__e59084c3__$_?component__"